import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AvatarService {

  private avatarUrlSubject = new BehaviorSubject<string>('');
  private avatar2UrlSubject = new BehaviorSubject<string>('');

  avatarUrl$ = this.avatarUrlSubject.asObservable();
  avatar2Url$ = this.avatar2UrlSubject.asObservable();

  updateAvatarUrl(url: string) {
    this.avatarUrlSubject.next(url);
  }

  updateAvatar2Url(url: string) {
    this.avatar2UrlSubject.next(url);
  }
}
